import dynamic from "next/dynamic";

import { SwiperSlide } from "swiper/react";

import PostItem from "components/molecules/PostItem";
const PostSlider = dynamic(() => import("components/organisms/PostSlider"), {
  ssr: false,
});

const CustomSwiperBreakpoint = (data) => {
  return {
    320: {
      slidesPerView: 1,
      spaceBetween: 40,
      slidesPerGroup: 1,
      allowTouchMove: data?.length > 1,
      autoplay: {
        delay: data?.length > 1 ? 2500 : 9999999999,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
    },

    1024: {
      slidesPerView: data?.length < 2 ? data?.length : 2,
      spaceBetween: 30,
      slidesPerGroup: data?.length < 2 ? data?.length : 2,
      allowTouchMove: data?.length > 2,
      autoplay: {
        delay: data?.length > 2 ? 2500 : 9999999999,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
    },
    1280: {
      slidesPerView: data?.length < 3 ? data?.length : 3,
      spaceBetween: 30,
      slidesPerGroup: data?.length < 3 ? data?.length : 3,
      allowTouchMove: data?.length > 3,
      autoplay: {
        delay: data?.length > 3 ? 2500 : 9999999999,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
    },
  };
};

export default function NewsSlider({ data }) {
  return (
    <>
      <PostSlider
        navResponsiveClass={
          data?.posts?.length > 3 ? "" : "hidden lg:flex xl:hidden"
        }
        breakpoints={CustomSwiperBreakpoint(data?.posts)}
      >
        {Array.isArray(data.posts) &&
          data?.posts?.length > 0 &&
          data?.posts?.map((item, index) => {
            return (
              <SwiperSlide
                key={index}
                className={`!h-auto lg:flex ${
                  data?.posts?.length === 2 && index < 1
                    ? "justify-end"
                    : "justify-start"
                }`}
              >
                <PostItem post={item} />
              </SwiperSlide>
            );
          })}
      </PostSlider>
    </>
  );
}
